var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.002 23.1299C12.002 23.1299 21.002 17.1299 21.002 10.1299C21.002 7.74293 20.0537 5.45375 18.3659 3.76592C16.6781 2.07809 14.3889 1.12988 12.002 1.12988C9.615 1.12988 7.32582 2.07809 5.63799 3.76592C3.95016 5.45375 3.00195 7.74293 3.00195 10.1299C3.00195 17.1299 12.002 23.1299 12.002 23.1299ZM15.002 10.1299C15.002 11.7867 13.6588 13.1299 12.002 13.1299C10.3451 13.1299 9.00195 11.7867 9.00195 10.1299C9.00195 8.47303 10.3451 7.12988 12.002 7.12988C13.6588 7.12988 15.002 8.47303 15.002 10.1299Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.6c9a5063894d61911114f7c495b5230c.svg";
export { ForwardRef as ReactComponent };